/**
 * useFoundationVideo — picks the right Aurum foundation video URL for
 * the current device. Mobile (≤ 768px viewport OR coarse-pointer touch
 * input) gets a 720p ~40 MB variant; desktop / tablet gets the full
 * 1080p ~147 MB version.
 *
 * The decision happens once at mount and is intentionally NOT reactive
 * to resize — we don't want to switch the video URL mid-session if the
 * user rotates their device. The selected URL is then probed by
 * <VideoImmersionScreen>, which falls back gracefully to the multi-clip
 * nature journey if either file is unreachable.
 *
 * Why a single hook? Both the Aurum Vision immersion and the Abundance
 * Living Vision Board now use the same bespoke foundation video — this
 * keeps the variant logic in one place so any future tuning (a tablet
 * tier, a Wi-Fi-only override, etc.) is a one-file change.
 */
import { useMemo } from 'react';

const DESKTOP_URL = '/api/video/aurum/aurum_foundation.mp4';
const MOBILE_URL  = '/api/video/aurum/aurum_foundation_mobile.mp4';

function detectMobile() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) return true;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
  } catch (_) { /* feature missing — fall through */ }
  return false;
}

export function useFoundationVideo() {
  return useMemo(() => (detectMobile() ? MOBILE_URL : DESKTOP_URL), []);
}

export default useFoundationVideo;
